import React, { useEffect, useState } from "react";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { makeStyles } from "@mui/styles";
import { Link } from "react-router-dom";
import emitter from "tiny-emitter/instance";
import { useSelector } from 'react-redux';

export default function MainListItems(props) {
	const classes = useStyles();
	const [bookbuilderCounter, setBookBuilderCounter] = useState(0);
	const [subscription, setSubscription] = useState("");
	const [hasalerts, setAlerts] = useState(false);

	const { sandboxedItems } = useSelector((state) => state.sandbox);

	useEffect(() => {
		emitter.on("applylistsubscription", () => {
			const selClient = JSON.parse(
				sessionStorage.getItem("selectedClient")
			);
			setSubscription(selClient?.subscription?.subscriptionName ?? "");
			setAlerts(selClient?.alerts ?? false);
		});

		emitter.on("bookbuilderCounter", () => {
			const count = JSON.parse(sessionStorage.getItem("books")).length;
			setBookBuilderCounter(count);
		});

		const selClient = JSON.parse(sessionStorage.getItem("selectedClient"));
		if (selClient !== null) {
			setSubscription(selClient?.subscription?.subscriptionName ?? "");
			setAlerts(selClient?.alerts ?? false);
		}

		return () => {
			emitter.off("bookbuilderCounter");
			emitter.off("applylistsubscription");
		};
	}, []); //eslint-disable-line

	React.useEffect(() => {
		if (props.activeRoute && props.activeRoute !== "/") {
			const UserTabs = JSON.parse(sessionStorage.getItem("UserTabs"));
			if (UserTabs?.length) {
				UserTabs[UserTabs.length - 1].endDateTime = new Date();
			}
			const tab = {
				startDateTime: new Date(),
				tabName: props.activeRoute,
				user_Tab_Activitties: [],
				viewed_clips: [],
			};
			UserTabs?.push(tab);
			sessionStorage.setItem("UserTabs", JSON.stringify(UserTabs));
		}
	}, [props.activeRoute]);

	return (
		<div>
			<ListItem
				selected={props.activeRoute === "/overview"}
				component={(props) => <Link {...props} to={"/overview"} />}
				classes={{ selected: classes.selected }}
				sx={{
					marginBottom: "4px",
					borderRadius: "10px",
					padding: "10px 16px",
					transition: "all 0.2s ease",
					"&:hover": {
						backgroundColor: "#F7F9FC",
					},
				}}
			>
				<ListItemIcon>
					{props.activeRoute === "/overview" ? (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<rect x="3" y="3" width="7" height="7" rx="1" fill="#3966D0"/>
							<rect x="3" y="14" width="7" height="7" rx="1" fill="#3966D0"/>
							<rect x="14" y="3" width="7" height="7" rx="1" fill="#3966D0"/>
							<rect x="14" y="14" width="7" height="7" rx="1" fill="#3966D0"/>
						</svg>
					) : (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<rect x="3" y="3" width="7" height="7" rx="1" fill="#D0D1D2"/>
							<rect x="3" y="14" width="7" height="7" rx="1" fill="#D0D1D2"/>
							<rect x="14" y="3" width="7" height="7" rx="1" fill="#D0D1D2"/>
							<rect x="14" y="14" width="7" height="7" rx="1" fill="#D0D1D2"/>
						</svg>
					)}
				</ListItemIcon>
				<ListItemText
					className={
						props.activeRoute === "/overview"
							? classes.textSelected
							: classes.text
					}
					primary="Overview"
				/>
			</ListItem>
			<ListItem
				selected={props.activeRoute === "/volume"}
				component={(props) => <Link {...props} to={"/volume"} />}
				classes={{ selected: classes.selected }}
				sx={{
					marginBottom: "4px",
					borderRadius: "10px",
					padding: "10px 16px",
					transition: "all 0.2s ease",
					"&:hover": {
						backgroundColor: "#F7F9FC",
					},
				}}
			>
				<ListItemIcon>
					{props.activeRoute === "/volume" ? (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M18 20V10"
								stroke="#3966D0"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M12 20V4"
								stroke="#3966D0"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M6 20V14"
								stroke="#3966D0"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					) : (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M18 20V10"
								stroke="#D0D1D2"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M12 20V4"
								stroke="#D0D1D2"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M6 20V14"
								stroke="#D0D1D2"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					)}
				</ListItemIcon>
				<ListItemText
					className={
						props.activeRoute === "/volume"
							? classes.textSelected
							: classes.text
					}
					primary="Volume"
				/>
			</ListItem>
			<ListItem
				selected={props.activeRoute === "/mediaType"}
				component={(props) => <Link {...props} to={"/mediaType"} />}
				classes={{ selected: classes.selected }}
				sx={{
					marginBottom: "4px",
					borderRadius: "10px",
					padding: "10px 16px",
					transition: "all 0.2s ease",
					"&:hover": {
						backgroundColor: "#F7F9FC",
					},
				}}
			>
				<ListItemIcon>
					{props.activeRoute === "/mediaType" ? (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<rect x="2" y="7" width="20" height="14" rx="2" stroke="#3966D0" strokeWidth="2"/>
							<circle cx="8.5" cy="9.5" r="1.5" fill="#3966D0"/>
							<path d="M2 18L7 13L12 18" stroke="#3966D0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
							<path d="M11 15L14 12L22 20" stroke="#3966D0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
							<path d="M14 3L12 5H16L14 3Z" fill="#3966D0"/>
							<path d="M18 5L16 7H20L18 5Z" fill="#3966D0"/>
						</svg>
					) : (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<rect x="2" y="7" width="20" height="14" rx="2" stroke="#D0D1D2" strokeWidth="2"/>
							<circle cx="8.5" cy="9.5" r="1.5" fill="#D0D1D2"/>
							<path d="M2 18L7 13L12 18" stroke="#D0D1D2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
							<path d="M11 15L14 12L22 20" stroke="#D0D1D2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
							<path d="M14 3L12 5H16L14 3Z" fill="#D0D1D2"/>
							<path d="M18 5L16 7H20L18 5Z" fill="#D0D1D2"/>
						</svg>
					)}
				</ListItemIcon>
				<ListItemText
					className={
						props.activeRoute === "/mediaType"
							? classes.textSelected
							: classes.text
					}
					primary="Media type"
				/>
			</ListItem>
			<ListItem
				selected={props.activeRoute === "/source"}
				component={(props) => <Link {...props} to={"/source"} />}
				classes={{ selected: classes.selected }}
				sx={{
					marginBottom: "4px",
					borderRadius: "10px",
					padding: "10px 16px",
					transition: "all 0.2s ease",
					"&:hover": {
						backgroundColor: "#F7F9FC",
					},
				}}
			>
				<ListItemIcon>
					{props.activeRoute === "/source" ? (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M13 2L3 14H12L11 22L21 10H12L13 2Z"
								stroke="#3966D0"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
								fill="none"
							/>
						</svg>
					) : (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M13 2L3 14H12L11 22L21 10H12L13 2Z"
								stroke="#D0D1D2"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
								fill="none"
							/>
						</svg>
					)}
				</ListItemIcon>
				<ListItemText
					className={
						props.activeRoute === "/source"
							? classes.textSelected
							: classes.text
					}
					primary="Source"
				/>
			</ListItem>
			<ListItem
				selected={props.activeRoute === "/region"}
				component={(props) => <Link {...props} to={"/region"} />}
				classes={{ selected: classes.selected }}
				sx={{
					marginBottom: "4px",
					borderRadius: "10px",
					padding: "10px 16px",
					transition: "all 0.2s ease",
					"&:hover": {
						backgroundColor: "#F7F9FC",
					},
				}}
			>
				<ListItemIcon>
					{props.activeRoute === "/region" ? (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle cx="12" cy="12" r="10" stroke="#3966D0" strokeWidth="2"/>
							<path d="M2 12H22" stroke="#3966D0" strokeWidth="2"/>
							<path d="M12 2C14.5 5 15.5 8.5 15.5 12C15.5 15.5 14.5 19 12 22C9.5 19 8.5 15.5 8.5 12C8.5 8.5 9.5 5 12 2Z" stroke="#3966D0" strokeWidth="2"/>
						</svg>
					) : (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle cx="12" cy="12" r="10" stroke="#D0D1D2" strokeWidth="2"/>
							<path d="M2 12H22" stroke="#D0D1D2" strokeWidth="2"/>
							<path d="M12 2C14.5 5 15.5 8.5 15.5 12C15.5 15.5 14.5 19 12 22C9.5 19 8.5 15.5 8.5 12C8.5 8.5 9.5 5 12 2Z" stroke="#D0D1D2" strokeWidth="2"/>
						</svg>
					)}
				</ListItemIcon>
				<ListItemText
					className={
						props.activeRoute === "/region"
							? classes.textSelected
							: classes.text
					}
					primary="Region"
				/>
			</ListItem>
			<ListItem
				selected={props.activeRoute === "/category"}
				component={(props) => <Link {...props} to={"/category"} />}
				classes={{ selected: classes.selected }}
				sx={{
					marginBottom: "4px",
					borderRadius: "10px",
					padding: "10px 16px",
					transition: "all 0.2s ease",
					"&:hover": {
						backgroundColor: "#F7F9FC",
					},
				}}
			>
				<ListItemIcon>
					{props.activeRoute === "/category" ? (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M12 20V10"
								stroke="#3966D0"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M18 20V4"
								stroke="#3966D0"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M6 20V16"
								stroke="#3966D0"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					) : (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M12 20V10"
								stroke="#D0D1D2"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M18 20V4"
								stroke="#D0D1D2"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M6 20V16"
								stroke="#D0D1D2"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					)}
				</ListItemIcon>
				<ListItemText
					className={
						props.activeRoute === "/category"
							? classes.textSelected
							: classes.text
					}
					primary="Category share"
				/>
			</ListItem>
			<ListItem
				selected={props.activeRoute === "/language"}
				component={(props) => <Link {...props} to={"/language"} />}
				classes={{ selected: classes.selected }}
				sx={{
					marginBottom: "4px",
					borderRadius: "10px",
					padding: "10px 16px",
					transition: "all 0.2s ease",
					"&:hover": {
						backgroundColor: "#F7F9FC",
					},
				}}
			>
				<ListItemIcon>
					{props.activeRoute === "/language" ? (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M5 8L10 3M10 3L15 8M10 3V15"
								stroke="#3966D0"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M19 16L14 21M14 21L9 16M14 21V9"
								stroke="#3966D0"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<circle cx="10" cy="15" r="1.5" fill="#3966D0"/>
							<circle cx="14" cy="9" r="1.5" fill="#3966D0"/>
						</svg>
					) : (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M5 8L10 3M10 3L15 8M10 3V15"
								stroke="#D0D1D2"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M19 16L14 21M14 21L9 16M14 21V9"
								stroke="#D0D1D2"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<circle cx="10" cy="15" r="1.5" fill="#D0D1D2"/>
							<circle cx="14" cy="9" r="1.5" fill="#D0D1D2"/>
						</svg>
					)}
				</ListItemIcon>
				<ListItemText
					className={
						props.activeRoute === "/language"
							? classes.textSelected
							: classes.text
					}
					primary="Language"
				/>
			</ListItem>
			{/* 			<ListItem
				selected={props.activeRoute === "/lsmsem"}
				component={(props) => <Link {...props} to={"/lsmsem"} />}
				classes={{ selected: classes.selected }}
			>
				<ListItemIcon>
					{props.activeRoute === "/lsmsem" ? (
						<svg
							width="30"
							height="30"
							viewBox="0 0 30 30"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M12.75 14.8125C12.5014 14.8125 12.2629 14.9113 12.0871 15.0871C11.9113 15.2629 11.8125 15.5014 11.8125 15.75C11.8125 15.9986 11.9113 16.2371 12.0871 16.4129C12.2629 16.5887 12.5014 16.6875 12.75 16.6875C12.8731 16.6875 12.995 16.6633 13.1088 16.6161C13.2225 16.569 13.3259 16.5 13.4129 16.4129C13.5 16.3259 13.569 16.2225 13.6161 16.1088C13.6633 15.995 13.6875 15.8731 13.6875 15.75C13.6875 15.6269 13.6633 15.505 13.6161 15.3912C13.569 15.2775 13.5 15.1741 13.4129 15.0871C13.3259 15 13.2225 14.931 13.1088 14.8839C12.995 14.8367 12.8731 14.8125 12.75 14.8125ZM17.25 14.8125C17.0014 14.8125 16.7629 14.9113 16.5871 15.0871C16.4113 15.2629 16.3125 15.5014 16.3125 15.75C16.3125 15.9986 16.4113 16.2371 16.5871 16.4129C16.7629 16.5887 17.0014 16.6875 17.25 16.6875C17.4986 16.6875 17.7371 16.5887 17.9129 16.4129C18.0887 16.2371 18.1875 15.9986 18.1875 15.75C18.1875 15.5014 18.0887 15.2629 17.9129 15.0871C17.7371 14.9113 17.4986 14.8125 17.25 14.8125ZM15 7.5C14.0151 7.5 13.0398 7.69399 12.1299 8.0709C11.2199 8.44781 10.3931 9.00026 9.6967 9.6967C8.29018 11.1032 7.5 13.0109 7.5 15C7.5 16.9891 8.29018 18.8968 9.6967 20.3033C10.3931 20.9997 11.2199 21.5522 12.1299 21.9291C13.0398 22.306 14.0151 22.5 15 22.5C16.9891 22.5 18.8968 21.7098 20.3033 20.3033C21.7098 18.8968 22.5 16.9891 22.5 15C22.5 14.0151 22.306 13.0398 21.9291 12.1299C21.5522 11.2199 20.9997 10.3931 20.3033 9.6967C19.6069 9.00026 18.7801 8.44781 17.8701 8.0709C16.9602 7.69399 15.9849 7.5 15 7.5V7.5ZM15 21C11.6925 21 9 18.3075 9 15C9 14.7825 9 14.565 9.0375 14.355C10.8075 13.5675 12.21 12.12 12.945 10.3275C14.3025 12.2475 16.5375 13.5 19.065 13.5C19.65 13.5 20.2125 13.4325 20.7525 13.305C20.91 13.8375 21 14.4075 21 15C21 18.3075 18.3075 21 15 21Z"
								fill="#3966D0"
							/>
						</svg>
					) : (
						<svg
							width="30"
							height="30"
							viewBox="0 0 30 30"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M12.75 14.8125C12.5014 14.8125 12.2629 14.9113 12.0871 15.0871C11.9113 15.2629 11.8125 15.5014 11.8125 15.75C11.8125 15.9986 11.9113 16.2371 12.0871 16.4129C12.2629 16.5887 12.5014 16.6875 12.75 16.6875C12.8731 16.6875 12.995 16.6633 13.1088 16.6161C13.2225 16.569 13.3259 16.5 13.4129 16.4129C13.5 16.3259 13.569 16.2225 13.6161 16.1088C13.6633 15.995 13.6875 15.8731 13.6875 15.75C13.6875 15.6269 13.6633 15.505 13.6161 15.3912C13.569 15.2775 13.5 15.1741 13.4129 15.0871C13.3259 15 13.2225 14.931 13.1088 14.8839C12.995 14.8367 12.8731 14.8125 12.75 14.8125ZM17.25 14.8125C17.0014 14.8125 16.7629 14.9113 16.5871 15.0871C16.4113 15.2629 16.3125 15.5014 16.3125 15.75C16.3125 15.9986 16.4113 16.2371 16.5871 16.4129C16.7629 16.5887 17.0014 16.6875 17.25 16.6875C17.4986 16.6875 17.7371 16.5887 17.9129 16.4129C18.0887 16.2371 18.1875 15.9986 18.1875 15.75C18.1875 15.5014 18.0887 15.2629 17.9129 15.0871C17.7371 14.9113 17.4986 14.8125 17.25 14.8125ZM15 7.5C14.0151 7.5 13.0398 7.69399 12.1299 8.0709C11.2199 8.44781 10.3931 9.00026 9.6967 9.6967C8.29018 11.1032 7.5 13.0109 7.5 15C7.5 16.9891 8.29018 18.8968 9.6967 20.3033C10.3931 20.9997 11.2199 21.5522 12.1299 21.9291C13.0398 22.306 14.0151 22.5 15 22.5C16.9891 22.5 18.8968 21.7098 20.3033 20.3033C21.7098 18.8968 22.5 16.9891 22.5 15C22.5 14.0151 22.306 13.0398 21.9291 12.1299C21.5522 11.2199 20.9997 10.3931 20.3033 9.6967C19.6069 9.00026 18.7801 8.44781 17.8701 8.0709C16.9602 7.69399 15.9849 7.5 15 7.5V7.5ZM15 21C11.6925 21 9 18.3075 9 15C9 14.7825 9 14.565 9.0375 14.355C10.8075 13.5675 12.21 12.12 12.945 10.3275C14.3025 12.2475 16.5375 13.5 19.065 13.5C19.65 13.5 20.2125 13.4325 20.7525 13.305C20.91 13.8375 21 14.4075 21 15C21 18.3075 18.3075 21 15 21Z"
								fill="#D0D1D2"
							/>
						</svg>
					)}
				</ListItemIcon>
				<ListItemText
					className={
						props.activeRoute === "/lsmsem"
							? classes.textSelected
							: classes.text
					}
					primary="LSM / SEM"
				/>
			</ListItem> */}
			<ListItem
				selected={props.activeRoute === "/value"}
				component={(props) => <Link {...props} to={"/value"} />}
				classes={{ selected: classes.selected }}
				sx={{
					marginBottom: "4px",
					borderRadius: "10px",
					padding: "10px 16px",
					transition: "all 0.2s ease",
					"&:hover": {
						backgroundColor: "#F7F9FC",
					},
				}}
			>
				<ListItemIcon>
					{props.activeRoute === "/value" ? (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
								stroke="#3966D0"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
								fill="none"
							/>
							<path d="M12 7V13" stroke="#3966D0" strokeWidth="1.5"/>
							<circle cx="12" cy="15" r="1" fill="#3966D0"/>
						</svg>
					) : (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
								stroke="#D0D1D2"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
								fill="none"
							/>
							<path d="M12 7V13" stroke="#D0D1D2" strokeWidth="1.5"/>
							<circle cx="12" cy="15" r="1" fill="#D0D1D2"/>
						</svg>
					)}
				</ListItemIcon>
				<ListItemText
					className={
						props.activeRoute === "/value"
							? classes.textSelected
							: classes.text
					}
					primary="Value"
				/>
			</ListItem>
			<ListItem
				selected={props.activeRoute === "/brand"}
				component={(props) => <Link {...props} to={"/brand"} />}
				classes={{ selected: classes.selected }}
				sx={{
					marginBottom: "4px",
					borderRadius: "10px",
					padding: "10px 16px",
					transition: "all 0.2s ease",
					"&:hover": {
						backgroundColor: "#F7F9FC",
					},
				}}
			>
				<ListItemIcon>
					{props.activeRoute === "/brand" ? (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M20.59 13.41L13.42 20.58C13.2343 20.766 13.0137 20.9135 12.7709 21.0141C12.5281 21.1148 12.2678 21.1666 12.005 21.1666C11.7422 21.1666 11.4819 21.1148 11.2391 21.0141C10.9963 20.9135 10.7757 20.766 10.59 20.58L2 12V2H12L20.59 10.59C20.9625 10.9647 21.1716 11.4716 21.1716 12C21.1716 12.5284 20.9625 13.0353 20.59 13.41V13.41Z"
								stroke="#3966D0"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path d="M7 7H7.01" stroke="#3966D0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
						</svg>
					) : (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M20.59 13.41L13.42 20.58C13.2343 20.766 13.0137 20.9135 12.7709 21.0141C12.5281 21.1148 12.2678 21.1666 12.005 21.1666C11.7422 21.1666 11.4819 21.1148 11.2391 21.0141C10.9963 20.9135 10.7757 20.766 10.59 20.58L2 12V2H12L20.59 10.59C20.9625 10.9647 21.1716 11.4716 21.1716 12C21.1716 12.5284 20.9625 13.0353 20.59 13.41V13.41Z"
								stroke="#D0D1D2"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path d="M7 7H7.01" stroke="#D0D1D2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
						</svg>
					)}
				</ListItemIcon>
				<ListItemText
					className={
						props.activeRoute === "/brand"
							? classes.textSelected
							: classes.text
					}
					primary="Brand"
				/>
			</ListItem>

			<ListItem
				selected={props.activeRoute === "/topic"}
				component={(props) => <Link {...props} to={"/topic"} />}
				classes={{ selected: classes.selected }}
				sx={{
					marginBottom: "4px",
					borderRadius: "10px",
					padding: "10px 16px",
					transition: "all 0.2s ease",
					"&:hover": {
						backgroundColor: "#F7F9FC",
					},
				}}
			>
				<ListItemIcon>
					{props.activeRoute === "/topic" ? (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M21.21 15.89A10 10 0 1 1 8 2.83"
								stroke="#3966D0"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M22 12A10 10 0 0 0 12 2v10z"
								stroke="#3966D0"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					) : (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M21.21 15.89A10 10 0 1 1 8 2.83"
								stroke="#D0D1D2"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M22 12A10 10 0 0 0 12 2v10z"
								stroke="#D0D1D2"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					)}
				</ListItemIcon>
				<ListItemText
					className={
						props.activeRoute === "/topic"
							? classes.textSelected
							: classes.text
					}
					primary="Share of voice"
				/>
			</ListItem>


			<ListItem
				selected={props.activeRoute === "/advertType"}
				component={(props) => <Link {...props} to={"/advertType"} />}
				classes={{ selected: classes.selected }}
				sx={{
					marginBottom: "4px",
					borderRadius: "10px",
					padding: "10px 16px",
					transition: "all 0.2s ease",
					"&:hover": {
						backgroundColor: "#F7F9FC",
					},
				}}
			>
				<ListItemIcon>
					{props.activeRoute === "/advertType" ? (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M18 8H5C4.46957 8 3.96086 8.21071 3.58579 8.58579C3.21071 8.96086 3 9.46957 3 10V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H18C18.5304 21 19.0391 20.7893 19.4142 20.4142C19.7893 20.0391 20 19.5304 20 19V10C20 9.46957 19.7893 8.96086 19.4142 8.58579C19.0391 8.21071 18.5304 8 18 8Z"
								stroke="#3966D0"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M12 17C13.6569 17 15 15.6569 15 14C15 12.3431 13.6569 11 12 11C10.3431 11 9 12.3431 9 14C9 15.6569 10.3431 17 12 17Z"
								stroke="#3966D0"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path d="M8.5 8V4C8.5 3.46957 8.71071 2.96086 9.08579 2.58579C9.46086 2.21071 9.96957 2 10.5 2H13.5C14.0304 2 14.5391 2.21071 14.9142 2.58579C15.2893 2.96086 15.5 3.46957 15.5 4V8" stroke="#3966D0" strokeWidth="2"/>
						</svg>
					) : (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M18 8H5C4.46957 8 3.96086 8.21071 3.58579 8.58579C3.21071 8.96086 3 9.46957 3 10V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H18C18.5304 21 19.0391 20.7893 19.4142 20.4142C19.7893 20.0391 20 19.5304 20 19V10C20 9.46957 19.7893 8.96086 19.4142 8.58579C19.0391 8.21071 18.5304 8 18 8Z"
								stroke="#D0D1D2"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M12 17C13.6569 17 15 15.6569 15 14C15 12.3431 13.6569 11 12 11C10.3431 11 9 12.3431 9 14C9 15.6569 10.3431 17 12 17Z"
								stroke="#D0D1D2"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path d="M8.5 8V4C8.5 3.46957 8.71071 2.96086 9.08579 2.58579C9.46086 2.21071 9.96957 2 10.5 2H13.5C14.0304 2 14.5391 2.21071 14.9142 2.58579C15.2893 2.96086 15.5 3.46957 15.5 4V8" stroke="#D0D1D2" strokeWidth="2"/>
						</svg>
					)}
				</ListItemIcon>
				<ListItemText
					className={
						props.activeRoute === "/advertType"
							? classes.textSelected
							: classes.text
					}
					primary="Advert type"
				/>
			</ListItem>
			<ListItem
				selected={props.activeRoute === "/data"}
				component={(props) => <Link {...props} to={"/data"} />}
				classes={{ selected: classes.selected }}
				sx={{
					marginBottom: "4px",
					borderRadius: "10px",
					padding: "10px 16px",
					transition: "all 0.2s ease",
					"&:hover": {
						backgroundColor: "#F7F9FC",
					},
				}}
			>
				<ListItemIcon>
					{props.activeRoute === "/data" ? (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<rect x="3" y="3" width="7" height="7" rx="1" stroke="#3966D0" strokeWidth="2"/>
							<rect x="14" y="3" width="7" height="7" rx="1" stroke="#3966D0" strokeWidth="2"/>
							<rect x="3" y="14" width="7" height="7" rx="1" stroke="#3966D0" strokeWidth="2"/>
							<rect x="14" y="14" width="7" height="7" rx="1" stroke="#3966D0" strokeWidth="2"/>
							<circle cx="6.5" cy="6.5" r="1" fill="#3966D0"/>
							<circle cx="17.5" cy="6.5" r="1" fill="#3966D0"/>
							<circle cx="6.5" cy="17.5" r="1" fill="#3966D0"/>
							<circle cx="17.5" cy="17.5" r="1" fill="#3966D0"/>
						</svg>
					) : (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<rect x="3" y="3" width="7" height="7" rx="1" stroke="#D0D1D2" strokeWidth="2"/>
							<rect x="14" y="3" width="7" height="7" rx="1" stroke="#D0D1D2" strokeWidth="2"/>
							<rect x="3" y="14" width="7" height="7" rx="1" stroke="#D0D1D2" strokeWidth="2"/>
							<rect x="14" y="14" width="7" height="7" rx="1" stroke="#D0D1D2" strokeWidth="2"/>
							<circle cx="6.5" cy="6.5" r="1" fill="#D0D1D2"/>
							<circle cx="17.5" cy="6.5" r="1" fill="#D0D1D2"/>
							<circle cx="6.5" cy="17.5" r="1" fill="#D0D1D2"/>
							<circle cx="17.5" cy="17.5" r="1" fill="#D0D1D2"/>
						</svg>
					)}
				</ListItemIcon>
				<ListItemText
					className={
						props.activeRoute === "/data"
							? classes.textSelected
							: classes.text
					}
					primary="Data"
				/>
			</ListItem>
			{props.user?.internal ? (
			<ListItem
				selected={props.activeRoute === "/newsletters"}
				component={(props) => <Link {...props} to={"/newsletters"} />}
				classes={{ selected: classes.selected }}
				sx={{
					marginBottom: "4px",
					borderRadius: "10px",
					padding: "10px 16px",
					transition: "all 0.2s ease",
					"&:hover": {
						backgroundColor: "#F7F9FC",
					},
				}}
			>
				<ListItemIcon>
					{props.activeRoute === "/newsletters" || props.activeRoute.startsWith("/newsletters") ? (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
								stroke="#3966D0"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M22 6L12 13L2 6"
								stroke="#3966D0"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					) : (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
								stroke="#D0D1D2"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M22 6L12 13L2 6"
								stroke="#D0D1D2"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					)}
				</ListItemIcon>
				<ListItemText
					className={
						props.activeRoute === "/newsletters" || props.activeRoute.startsWith("/newsletters")
							? classes.textSelected
							: classes.text
					}
					primary="Newsletters"
				/>
			</ListItem>
			) : null}	
			<ListItem
				selected={props.activeRoute === "/sandbox"}
				component={(props) => <Link {...props} to={"/sandbox"} />}
				classes={{ selected: classes.selected }}
				sx={{
					marginBottom: "4px",
					borderRadius: "10px",
					padding: "10px 16px",
					transition: "all 0.2s ease",
					"&:hover": {
						backgroundColor: "#F7F9FC",
					},
				}}
			>
				<ListItemIcon>
					{props.activeRoute === "/sandbox" ? (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M21 16V8C20.9996 7.64927 20.9071 7.30481 20.7315 7.00116C20.556 6.69751 20.3037 6.44536 20 6.27L13 2.27C12.696 2.09446 12.3511 2.00205 12 2.00205C11.6489 2.00205 11.304 2.09446 11 2.27L4 6.27C3.69626 6.44536 3.44398 6.69751 3.26846 7.00116C3.09294 7.30481 3.00036 7.64927 3 8V16C3.00036 16.3507 3.09294 16.6952 3.26846 16.9988C3.44398 17.3025 3.69626 17.5546 4 17.73L11 21.73C11.304 21.9055 11.6489 21.998 12 21.998C12.3511 21.998 12.696 21.9055 13 21.73L20 17.73C20.3037 17.5546 20.556 17.3025 20.7315 16.9988C20.9071 16.6952 20.9996 16.3507 21 16Z"
								stroke="#3966D0"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path d="M3.27002 6.96L12 12.01L20.73 6.96" stroke="#3966D0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
							<path d="M12 22.08V12" stroke="#3966D0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
						</svg>
					) : (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M21 16V8C20.9996 7.64927 20.9071 7.30481 20.7315 7.00116C20.556 6.69751 20.3037 6.44536 20 6.27L13 2.27C12.696 2.09446 12.3511 2.00205 12 2.00205C11.6489 2.00205 11.304 2.09446 11 2.27L4 6.27C3.69626 6.44536 3.44398 6.69751 3.26846 7.00116C3.09294 7.30481 3.00036 7.64927 3 8V16C3.00036 16.3507 3.09294 16.6952 3.26846 16.9988C3.44398 17.3025 3.69626 17.5546 4 17.73L11 21.73C11.304 21.9055 11.6489 21.998 12 21.998C12.3511 21.998 12.696 21.9055 13 21.73L20 17.73C20.3037 17.5546 20.556 17.3025 20.7315 16.9988C20.9071 16.6952 20.9996 16.3507 21 16Z"
								stroke="#D0D1D2"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path d="M3.27002 6.96L12 12.01L20.73 6.96" stroke="#D0D1D2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
							<path d="M12 22.08V12" stroke="#D0D1D2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
						</svg>
					)}
				</ListItemIcon>
				<ListItemText
					className={
						props.activeRoute === "/sandbox"
							? classes.textSelected
							: classes.text
					}
					primary="Sandbox"
				/>
				<div
					style={{
						position: "absolute",
						right: 16,
						backgroundColor: "#DC2626",
						color: "#fff",
						fontSize: 11,
						fontFamily: "Poppins-SemiBold",
						fontWeight: 600,
						minWidth: 22,
						height: 22,
						borderRadius: 11,
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						padding: "0 6px",
						boxShadow: "0 2px 4px rgba(220, 38, 38, 0.2)",
					}}
				>
					{sandboxedItems.length}
				</div>
			</ListItem>

			<ListItem
				selected={props.activeRoute === "/sentiment"}
				component={(props) => <Link {...props} to={"/sentiment"} />}
				classes={{ selected: classes.selected }}
				sx={{
					marginBottom: "4px",
					borderRadius: "10px",
					padding: "10px 16px",
					transition: "all 0.2s ease",
					"&:hover": {
						backgroundColor: "#F7F9FC",
					},
				}}
			>
				<ListItemIcon>
					{props.activeRoute === "/sentiment" ? (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle cx="12" cy="12" r="10" stroke="#3966D0" strokeWidth="2"/>
							<path d="M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14" stroke="#3966D0" strokeWidth="2" strokeLinecap="round"/>
							<circle cx="9" cy="9" r="1" fill="#3966D0"/>
							<circle cx="15" cy="9" r="1" fill="#3966D0"/>
						</svg>
					) : (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle cx="12" cy="12" r="10" stroke="#D0D1D2" strokeWidth="2"/>
							<path d="M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14" stroke="#D0D1D2" strokeWidth="2" strokeLinecap="round"/>
							<circle cx="9" cy="9" r="1" fill="#D0D1D2"/>
							<circle cx="15" cy="9" r="1" fill="#D0D1D2"/>
						</svg>
					)}
				</ListItemIcon>
				<ListItemText
					className={
						props.activeRoute === "/sentiment"
							? classes.textSelected
							: classes.text
					}
					primary="Sentiment"
				/>
			</ListItem>
			<ListItem
				selected={props.activeRoute === "/topAuthors"}
				component={(props) => <Link {...props} to={"/topAuthors"} />}
				classes={{ selected: classes.selected }}
				sx={{
					marginBottom: "4px",
					borderRadius: "10px",
					padding: "10px 16px",
					transition: "all 0.2s ease",
					"&:hover": {
						backgroundColor: "#F7F9FC",
					},
				}}
			>
				<ListItemIcon>
					{props.activeRoute === "/topAuthors" ? (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
								stroke="#3966D0"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<circle cx="9" cy="7" r="4" stroke="#3966D0" strokeWidth="2"/>
							<path
								d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13"
								stroke="#3966D0"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88"
								stroke="#3966D0"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					) : (
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
								stroke="#D0D1D2"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<circle cx="9" cy="7" r="4" stroke="#D0D1D2" strokeWidth="2"/>
							<path
								d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13"
								stroke="#D0D1D2"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path
								d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88"
								stroke="#D0D1D2"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					)}
				</ListItemIcon>
				<ListItemText
					className={
						props.activeRoute === "/topAuthors"
							? classes.textSelected
							: classes.text
					}
					primary="Top authors"
				/>
			</ListItem>
			{subscription === "MEDIUM" ? (
				<ListItem
					selected={props.activeRoute === "/socialMediaEngagement"}
					component={(props) => (
						<Link {...props} to={"/socialMediaEngagement"} />
					)}
					classes={{ selected: classes.selected }}
					sx={{
						marginBottom: "4px",
						borderRadius: "10px",
						padding: "10px 16px",
						transition: "all 0.2s ease",
						"&:hover": {
							backgroundColor: "#F7F9FC",
						},
					}}
				>
					<ListItemIcon>
						{props.activeRoute === "/socialMediaEngagement" ? (
							<svg
								width="14"
								height="17"
								viewBox="0 0 14 17"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
								style={{ marginLeft: 7 }}
							>
								<path
									d="M11.5 11.25H2.5V10.575C2.5 9.075 5.5 8.25 7 8.25C8.5 8.25 11.5 9.075 11.5 10.575V11.25ZM7 3.225C8.125 3.225 9.025 4.125 9.025 5.25C9.025 6.375 8.125 7.275 7 7.275C5.875 7.275 4.975 6.375 4.975 5.25C4.975 4.125 5.875 3.225 7 3.225ZM12.25 0.75H1.75C0.9175 0.75 0.25 1.4175 0.25 2.25V12.75C0.25 13.1478 0.408035 13.5294 0.68934 13.8107C0.970644 14.092 1.35218 14.25 1.75 14.25H4.75L7 16.5L9.25 14.25H12.25C12.6478 14.25 13.0294 14.092 13.3107 13.8107C13.592 13.5294 13.75 13.1478 13.75 12.75V2.25C13.75 1.4175 13.075 0.75 12.25 0.75Z"
									fill="#3966D0"
								/>
							</svg>
						) : (
							<svg
								width="14"
								height="17"
								viewBox="0 0 14 17"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
								style={{ marginLeft: 7 }}
							>
								<path
									d="M11.5 11.25H2.5V10.575C2.5 9.075 5.5 8.25 7 8.25C8.5 8.25 11.5 9.075 11.5 10.575V11.25ZM7 3.225C8.125 3.225 9.025 4.125 9.025 5.25C9.025 6.375 8.125 7.275 7 7.275C5.875 7.275 4.975 6.375 4.975 5.25C4.975 4.125 5.875 3.225 7 3.225ZM12.25 0.75H1.75C0.9175 0.75 0.25 1.4175 0.25 2.25V12.75C0.25 13.1478 0.408035 13.5294 0.68934 13.8107C0.970644 14.092 1.35218 14.25 1.75 14.25H4.75L7 16.5L9.25 14.25H12.25C12.6478 14.25 13.0294 14.092 13.3107 13.8107C13.592 13.5294 13.75 13.1478 13.75 12.75V2.25C13.75 1.4175 13.075 0.75 12.25 0.75Z"
									fill="#D0D1D2"
								/>
							</svg>
						)}
					</ListItemIcon>
					<ListItemText
						className={
							props.activeRoute === "/socialMediaEngagement"
								? classes.textSelected
								: classes.text
						}
						primary="Social Media Engagement"
					/>
				</ListItem>
			) : null}
			{hasalerts ? (
				<ListItem
					selected={props.activeRoute === "/alerthistory"}
					component={(props) => (
						<Link {...props} to={"/alerthistory"} />
					)}
					classes={{ selected: classes.selected }}
					sx={{
						marginBottom: "4px",
						borderRadius: "10px",
						padding: "10px 16px",
						transition: "all 0.2s ease",
						"&:hover": {
							backgroundColor: "#F7F9FC",
						},
					}}
				>
					<ListItemIcon>
						{props.activeRoute === "/alerthistory" ? (
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
									stroke="#3966D0"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
								<path
									d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
									stroke="#3966D0"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
								<circle cx="18" cy="6" r="3" fill="#3966D0"/>
							</svg>
						) : (
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z"
									stroke="#D0D1D2"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
								<path
									d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
									stroke="#D0D1D2"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
								<circle cx="18" cy="6" r="3" fill="#D0D1D2"/>
							</svg>
						)}
					</ListItemIcon>
					<ListItemText
						className={
							props.activeRoute === "/alerthistory"
								? classes.textSelected
								: classes.text
						}
						primary="Alert History"
					/>
				</ListItem>
			) : null}
			{props.user?.book ? (
				<ListItem
					selected={props.activeRoute === "/bookBuilder"}
					component={(props) => (
						<Link {...props} to={"/bookBuilder"} />
					)}
					classes={{ selected: classes.selected }}
					sx={{
						marginBottom: "4px",
						borderRadius: "10px",
						padding: "10px 16px",
						transition: "all 0.2s ease",
						"&:hover": {
							backgroundColor: "#F7F9FC",
						},
					}}
				>
					<ListItemIcon>
						{props.activeRoute === "/bookBuilder" ? (
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M4 19.5C4 18.837 4.26339 18.2011 4.73223 17.7322C5.20107 17.2634 5.83696 17 6.5 17H20"
									stroke="#3966D0"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
								<path
									d="M6.5 2H20V22H6.5C5.83696 22 5.20107 21.7366 4.73223 21.2678C4.26339 20.7989 4 20.163 4 19.5V4.5C4 3.83696 4.26339 3.20107 4.73223 2.73223C5.20107 2.26339 5.83696 2 6.5 2V2Z"
									stroke="#3966D0"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
								<line x1="12" y1="8" x2="12" y2="14" stroke="#3966D0" strokeWidth="2" strokeLinecap="round"/>
								<line x1="15" y1="11" x2="9" y2="11" stroke="#3966D0" strokeWidth="2" strokeLinecap="round"/>
							</svg>
						) : (
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M4 19.5C4 18.837 4.26339 18.2011 4.73223 17.7322C5.20107 17.2634 5.83696 17 6.5 17H20"
									stroke="#D0D1D2"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
								<path
									d="M6.5 2H20V22H6.5C5.83696 22 5.20107 21.7366 4.73223 21.2678C4.26339 20.7989 4 20.163 4 19.5V4.5C4 3.83696 4.26339 3.20107 4.73223 2.73223C5.20107 2.26339 5.83696 2 6.5 2V2Z"
									stroke="#D0D1D2"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
								<line x1="12" y1="8" x2="12" y2="14" stroke="#D0D1D2" strokeWidth="2" strokeLinecap="round"/>
								<line x1="15" y1="11" x2="9" y2="11" stroke="#D0D1D2" strokeWidth="2" strokeLinecap="round"/>
							</svg>
						)}
					</ListItemIcon>
					<ListItemText
						className={
							props.activeRoute === "/bookBuilder"
								? classes.textSelected
								: classes.text
						}
						primary="Book Builder"
					/>
					<div
						style={{
							position: "absolute",
							right: 16,
							backgroundColor: "#DC2626",
							color: "#fff",
							fontSize: 11,
							fontFamily: "Poppins-SemiBold",
							fontWeight: 600,
							minWidth: 22,
							height: 22,
							borderRadius: 11,
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							padding: "0 6px",
							boxShadow: "0 2px 4px rgba(220, 38, 38, 0.2)",
						}}
					>
						{bookbuilderCounter}
					</div>
				</ListItem>
			) : null}
		</div>
	);
}

const useStyles = makeStyles((theme) => ({
	selected: {
		backgroundColor: "#EBF0FA!important",
		borderRadius: 10,
		borderLeft: "3px solid #3966D0",
		paddingLeft: "13px!important",
		"&:hover": {
			backgroundColor: "#EBF0FA!important",
		},
	},
	text: {
		fontSize: 14,
		fontFamily: "Poppins",
		fontWeight: 500,
		color: "#4A5568",
		letterSpacing: "-0.01em",
		"& .MuiListItemText-primary": {
			fontSize: 14,
			fontWeight: 500,
		},
	},
	textSelected: {
		fontSize: 14,
		fontFamily: "Poppins-SemiBold",
		fontWeight: 600,
		color: "#3966D0",
		letterSpacing: "-0.01em",
		"& .MuiListItemText-primary": {
			fontSize: 14,
			fontWeight: 600,
		},
	},
}));